import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-043f7a74")

_pushScopeId("data-v-043f7a74")
const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = { class: "t-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString($props.title), 1),
    ($props.href)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: $props.href,
          class: "btn link-btn"
        }, {
          default: _withId(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('labels.more')), 1),
            _createVNode(_component_svg_icon, { name: "arrowright" })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
})